// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               v4.25.3
// source: messenger/teleop_bot_service.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { FileDescriptorProto as FileDescriptorProto1 } from "ts-proto-descriptors";
import { protoMetadata as protoMetadata1, Timestamp } from "../google/protobuf/timestamp";
import { Pose, protoMetadata as protoMetadata2, Vector3 } from "./geometry";

export const protobufPackage = "teleopbot";

export enum TeleopStatus {
  WAIT_FOR_TELEOP = 0,
  TELEOP = 1,
  STOPPING = 2,
  STOPPED = 3,
  ERROR = 4,
  UNRECOGNIZED = -1,
}

export function teleopStatusFromJSON(object: any): TeleopStatus {
  switch (object) {
    case 0:
    case "WAIT_FOR_TELEOP":
      return TeleopStatus.WAIT_FOR_TELEOP;
    case 1:
    case "TELEOP":
      return TeleopStatus.TELEOP;
    case 2:
    case "STOPPING":
      return TeleopStatus.STOPPING;
    case 3:
    case "STOPPED":
      return TeleopStatus.STOPPED;
    case 4:
    case "ERROR":
      return TeleopStatus.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TeleopStatus.UNRECOGNIZED;
  }
}

export function teleopStatusToJSON(object: TeleopStatus): string {
  switch (object) {
    case TeleopStatus.WAIT_FOR_TELEOP:
      return "WAIT_FOR_TELEOP";
    case TeleopStatus.TELEOP:
      return "TELEOP";
    case TeleopStatus.STOPPING:
      return "STOPPING";
    case TeleopStatus.STOPPED:
      return "STOPPED";
    case TeleopStatus.ERROR:
      return "ERROR";
    case TeleopStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RobotFrame {
  WORLD = 0,
  TOOLTIP = 1,
  UNRECOGNIZED = -1,
}

export function robotFrameFromJSON(object: any): RobotFrame {
  switch (object) {
    case 0:
    case "WORLD":
      return RobotFrame.WORLD;
    case 1:
    case "TOOLTIP":
      return RobotFrame.TOOLTIP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RobotFrame.UNRECOGNIZED;
  }
}

export function robotFrameToJSON(object: RobotFrame): string {
  switch (object) {
    case RobotFrame.WORLD:
      return "WORLD";
    case RobotFrame.TOOLTIP:
      return "TOOLTIP";
    case RobotFrame.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Which teleop modality the bot is configured to run.
 * DISABLED means no modality is active (teleop is effectively off).
 */
export enum TeleopMode {
  TELEOP_MODE_DISABLED = 0,
  TELEOP_MODE_IOS = 1,
  TELEOP_MODE_HEADSET = 2,
  TELEOP_MODE_HAPTIC = 3,
  TELEOP_MODE_DEMONSTRATION_REPLAY = 4,
  UNRECOGNIZED = -1,
}

export function teleopModeFromJSON(object: any): TeleopMode {
  switch (object) {
    case 0:
    case "TELEOP_MODE_DISABLED":
      return TeleopMode.TELEOP_MODE_DISABLED;
    case 1:
    case "TELEOP_MODE_IOS":
      return TeleopMode.TELEOP_MODE_IOS;
    case 2:
    case "TELEOP_MODE_HEADSET":
      return TeleopMode.TELEOP_MODE_HEADSET;
    case 3:
    case "TELEOP_MODE_HAPTIC":
      return TeleopMode.TELEOP_MODE_HAPTIC;
    case 4:
    case "TELEOP_MODE_DEMONSTRATION_REPLAY":
      return TeleopMode.TELEOP_MODE_DEMONSTRATION_REPLAY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TeleopMode.UNRECOGNIZED;
  }
}

export function teleopModeToJSON(object: TeleopMode): string {
  switch (object) {
    case TeleopMode.TELEOP_MODE_DISABLED:
      return "TELEOP_MODE_DISABLED";
    case TeleopMode.TELEOP_MODE_IOS:
      return "TELEOP_MODE_IOS";
    case TeleopMode.TELEOP_MODE_HEADSET:
      return "TELEOP_MODE_HEADSET";
    case TeleopMode.TELEOP_MODE_HAPTIC:
      return "TELEOP_MODE_HAPTIC";
    case TeleopMode.TELEOP_MODE_DEMONSTRATION_REPLAY:
      return "TELEOP_MODE_DEMONSTRATION_REPLAY";
    case TeleopMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Pose-smoothing filter applied between leader input and follower commands. */
export enum TeleopFilterType {
  TELEOP_FILTER_NONE = 0,
  TELEOP_FILTER_EMA = 1,
  TELEOP_FILTER_SMOOTH_DAMP = 2,
  UNRECOGNIZED = -1,
}

export function teleopFilterTypeFromJSON(object: any): TeleopFilterType {
  switch (object) {
    case 0:
    case "TELEOP_FILTER_NONE":
      return TeleopFilterType.TELEOP_FILTER_NONE;
    case 1:
    case "TELEOP_FILTER_EMA":
      return TeleopFilterType.TELEOP_FILTER_EMA;
    case 2:
    case "TELEOP_FILTER_SMOOTH_DAMP":
      return TeleopFilterType.TELEOP_FILTER_SMOOTH_DAMP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return TeleopFilterType.UNRECOGNIZED;
  }
}

export function teleopFilterTypeToJSON(object: TeleopFilterType): string {
  switch (object) {
    case TeleopFilterType.TELEOP_FILTER_NONE:
      return "TELEOP_FILTER_NONE";
    case TeleopFilterType.TELEOP_FILTER_EMA:
      return "TELEOP_FILTER_EMA";
    case TeleopFilterType.TELEOP_FILTER_SMOOTH_DAMP:
      return "TELEOP_FILTER_SMOOTH_DAMP";
    case TeleopFilterType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Per-tick teleop blackbox sample, published for start-jolt diagnostics. Most
 * fields are the raw leader device readout — `pose`, `velocity`,
 * `angular_velocity`, `joint_torque` come straight from the servo shared-memory
 * block (device frame/units) before origin subtraction or scaling, and `seq` is
 * the SHM frame counter so consumers can detect stale reads and ordering.
 * Velocity near zero while pose moves ⇒ a reported-value artifact rather than
 * physical stylus motion. A few fields are teleop-side derived, NOT raw:
 * `commanded_pose` and `reference` are robot-world-frame poses (see their
 * comments) — carried on the same record as the raw pose so the mapping and
 * force loop can be read per-tick without joining async topics.
 */
export interface TouchDeviceSample {
  pose:
    | Pose
    | undefined;
  /** linear velocity, device units/s */
  velocity: Vector3 | undefined;
  seq: number;
  /** Stylus button press state (Touch X has two buttons). */
  button1: boolean;
  /** back / dark */
  button2: boolean;
  /**
   * --- Diagnostic fields for teleop start-jolt investigation ---
   * The haptic force teleop commanded to the device this tick (device frame,
   * N), and the reference pose the force loop used (compliance target, or the
   * robot's actual pose when the compliance target is stale). Together with
   * pose/velocity these let force = -K*(commanded - reference) and the energy
   * balance (force*velocity) be computed exactly from the recording.
   */
  appliedForce: Vector3 | undefined;
  reference:
    | Pose
    | undefined;
  /**
   * Raw device actuation/health straight from libHD, to distinguish a device
   * servo fault from hand motion. joint_torque is HD_CURRENT_JOINT_TORQUE (the
   * motors' actual torque — nonzero here while applied_force is ~0 means the
   * device drove the stylus itself). error_code is the raw hdGetError code
   * (0 = HD_SUCCESS). calibration_status is hdCheckCalibration
   * (0x5000 OK / 0x5001 needs-update / 0x5002 needs-manual).
   */
  jointTorque: number[];
  errorCode: number;
  calibrationStatus: number;
  /**
   * Angular velocity of the stylus (device frame, rad/s) — shows whether a
   * spike is translation-only or the whole pose.
   */
  angularVelocity:
    | Vector3
    | undefined;
  /**
   * libHD's instantaneous servo loop rate (Hz), HD_INSTANTANEOUS_UPDATE_RATE.
   * libHD derives velocity as Δpose/Δt, so a dip here at the same tick as a
   * velocity spike means the spike is a servo-timing artifact (a long Δt),
   * not real motion or a device fault. Nominal is ~1000 Hz.
   */
  updateRateHz: number;
  /**
   * The follower target pose teleop derived from `pose` this tick (robot world
   * frame) — i.e. the WritePoseCompliance command — recorded on the same
   * sample as the raw device `pose` (device frame). Having both in one record
   * makes the mapping (origin subtraction, axis flip, ~4x position scaling)
   * and any engage glitch visible per-tick without joining async topics.
   * Unset until the first control tick sends a command.
   */
  commandedPose: Pose | undefined;
}

export interface Empty {
}

export interface CartesianPose {
  x: number;
  y: number;
  z: number;
  i: number;
  j: number;
  k: number;
  w: number;
}

export interface GripperBounds {
  min: number;
  max: number;
}

export interface StartTeleopPayload {
  clientId: string;
  /**
   * Optional per-session overrides applied atomically on start. Used
   * when the caller owns the start (WebXR, Touch X) and wants to
   * bundle topology + overrides into one RPC. Cleared on stop along
   * with any pre-staged overrides from `SetTeleopSessionConfig`.
   */
  sessionConfig?: TeleopSessionConfig | undefined;
}

export interface StopTeleopPayload {
  clientId?: string | undefined;
  errorMessage?: string | undefined;
}

export interface TeleopClient {
  clientId: string;
  clientType: string;
  connectedAt: Date | undefined;
}

export interface TeleopState {
  config: TeleopSessionConfig | undefined;
  status: TeleopStatus;
  errors: string[];
  botsInSync: boolean;
  robotFrame: RobotFrame;
  gripperBounds?: GripperBounds | undefined;
  connectedClients: TeleopClient[];
  filterType: string;
  /**
   * Persisted (robot-global) teleop mode from TeleopSettings, independent of any
   * session `config.mode_override`. Lets a consumer evaluate the effective mode
   * (override if set, else global) from this state alone, without a separate
   * settings lookup. Unset before persisted settings first arrive.
   */
  globalMode?: TeleopMode | undefined;
}

export interface BoltHeadPosition {
  pitch: number;
  yaw: number;
  roll: number;
}

export interface DemonstrationSession {
  recordingId: string;
  frameTransform?:
    | CartesianPose
    | undefined;
  /**
   * Optional sphere-trim window: teleop-bot streams only frames whose
   * timestamp falls in [start, end] (inclusive), anchoring the window's first
   * frame to the live tooltip. Timestamps are recorder seconds. Both unset ⇒
   * full recording; end alone unset ⇒ to recording end.
   */
  replayStartTimestamp?: number | undefined;
  replayEndTimestamp?:
    | number
    | undefined;
  /**
   * Playback speed multiplier vs recorded cadence (1.0 ⇒ recorded). Range
   * 0.1–2.0 enforced by the runner; unset ⇒ 1.0. Speed-ups are realized by
   * downsampling frames teleop-bot side, not by sending faster.
   */
  playbackSpeedMultiplier?: number | undefined;
}

export interface TeleopSessionConfig {
  isSecondary?: boolean | undefined;
  bots: string[];
  enableBoltHeadTracking?:
    | boolean
    | undefined;
  /**
   * Session-scoped overrides. Each unset field falls back to the
   * corresponding TeleopSettings (persisted) value. Cleared by
   * teleop-bot on session stop, so the next session reverts to
   * persisted defaults — the persisted Feathers row is never touched.
   */
  modeOverride?: TeleopMode | undefined;
  gripperVelocityOverride?: number | undefined;
  gripperMinOverride?: number | undefined;
  gripperMaxOverride?: number | undefined;
  demonstrationSession?: DemonstrationSession | undefined;
}

export interface ToggleBotPayload {
  botId: string;
  isEnabled: boolean;
}

export interface SetRatioControlPayload {
  enabled: boolean;
  movementValue: number;
  rotationValue?: number | undefined;
}

export interface SetGripperBoundsPayload {
  bounds: GripperBounds | undefined;
}

export interface SetRobotFramePayload {
  frame: RobotFrame;
}

export interface SetBoltHeadPositionPayload {
  position: BoltHeadPosition | undefined;
}

/**
 * Persistent user preference, persisted in feathers-bot's teleopSettings
 * Feathers service and pushed to teleop-bot via ConfigureTeleop. All tuning
 * knobs a user expects the robot to remember across reboots live here.
 * Per-session state (e.g. is_secondary, bots) is separate and lives in
 * TeleopSessionConfig.
 */
export interface TeleopSettings {
  mode: TeleopMode;
  arDevicePort: number;
  gripperVelocity: number;
  /**
   * Marked optional so proto3 presence tracking lets SetTeleopConfig
   * distinguish "client wants flipXy=false" from "client did not send flipXy"
   * (a default-value bool can't otherwise be told apart from absence).
   */
  flipXy?: boolean | undefined;
  frequency: number;
  /**
   * Marked optional for the same SetTeleopConfig presence reason as flip_xy:
   * TELEOP_FILTER_NONE (=0, "identity") is a valid user choice, so the proto3
   * default must be distinguishable from "client did not send filter_type".
   */
  filterType?: TeleopFilterType | undefined;
  emaSmoothingFactor?: number | undefined;
  smoothDampSmoothTime?: number | undefined;
  smoothDampMaxAngularSpeed?: number | undefined;
  smoothDampMaxSpeed?: number | undefined;
  smoothDampMaxAccel?: number | undefined;
  headPoseUdpHost?: string | undefined;
  headPoseUdpPort?: number | undefined;
  hapticDevicePositionScale?: number | undefined;
  hapticDeviceRotationScale?: number | undefined;
  hapticDeviceRotationFrame?: string | undefined;
  hapticDeviceForceStiffnessK?: number | undefined;
  hapticDeviceForceDampingB?:
    | number
    | undefined;
  /** Normalized 0..1; mapped onto the active leader gripper. */
  gripperMin?: number | undefined;
  gripperMax?:
    | number
    | undefined;
  /**
   * Per-robot calibration: compass heading (degrees clockwise from true
   * north) of the robot's gravity-aligned world +X axis. Required for
   * iOS teleop. Absent ⇒ uncalibrated; teleop-bot refuses to start the
   * iOS modality.
   */
  worldCompassHeadingDeg?:
    | number
    | undefined;
  /**
   * Haptic-device gripper button (button 2) behavior. When false (default)
   * the button is momentary: hold = close, release = open. When true it
   * latches: each press alternates the follower gripper between its
   * configured min (closed) and max (open) bounds. Marked optional so
   * proto3 presence tracking lets SetTeleopConfig distinguish an explicit
   * `false` from an unset field (same rationale as flip_xy).
   */
  hapticDeviceGripperButtonToggle?: boolean | undefined;
}

function createBaseTouchDeviceSample(): TouchDeviceSample {
  return {
    pose: undefined,
    velocity: undefined,
    seq: 0,
    button1: false,
    button2: false,
    appliedForce: undefined,
    reference: undefined,
    jointTorque: [],
    errorCode: 0,
    calibrationStatus: 0,
    angularVelocity: undefined,
    updateRateHz: 0,
    commandedPose: undefined,
  };
}

export const TouchDeviceSample: MessageFns<TouchDeviceSample> = {
  encode(message: TouchDeviceSample, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pose !== undefined) {
      Pose.encode(message.pose, writer.uint32(10).fork()).join();
    }
    if (message.velocity !== undefined) {
      Vector3.encode(message.velocity, writer.uint32(18).fork()).join();
    }
    if (message.seq !== 0) {
      writer.uint32(24).uint64(message.seq);
    }
    if (message.button1 !== false) {
      writer.uint32(32).bool(message.button1);
    }
    if (message.button2 !== false) {
      writer.uint32(40).bool(message.button2);
    }
    if (message.appliedForce !== undefined) {
      Vector3.encode(message.appliedForce, writer.uint32(50).fork()).join();
    }
    if (message.reference !== undefined) {
      Pose.encode(message.reference, writer.uint32(58).fork()).join();
    }
    writer.uint32(66).fork();
    for (const v of message.jointTorque) {
      writer.double(v);
    }
    writer.join();
    if (message.errorCode !== 0) {
      writer.uint32(72).uint32(message.errorCode);
    }
    if (message.calibrationStatus !== 0) {
      writer.uint32(80).uint32(message.calibrationStatus);
    }
    if (message.angularVelocity !== undefined) {
      Vector3.encode(message.angularVelocity, writer.uint32(90).fork()).join();
    }
    if (message.updateRateHz !== 0) {
      writer.uint32(97).double(message.updateRateHz);
    }
    if (message.commandedPose !== undefined) {
      Pose.encode(message.commandedPose, writer.uint32(106).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TouchDeviceSample {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTouchDeviceSample();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.pose = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.velocity = Vector3.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.seq = longToNumber(reader.uint64());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.button1 = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.button2 = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.appliedForce = Vector3.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.reference = Pose.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag === 65) {
            message.jointTorque.push(reader.double());

            continue;
          }

          if (tag === 66) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.jointTorque.push(reader.double());
            }

            continue;
          }

          break;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.errorCode = reader.uint32();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.calibrationStatus = reader.uint32();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.angularVelocity = Vector3.decode(reader, reader.uint32());
          continue;
        }
        case 12: {
          if (tag !== 97) {
            break;
          }

          message.updateRateHz = reader.double();
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.commandedPose = Pose.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TouchDeviceSample {
    return {
      pose: isSet(object.pose) ? Pose.fromJSON(object.pose) : undefined,
      velocity: isSet(object.velocity) ? Vector3.fromJSON(object.velocity) : undefined,
      seq: isSet(object.seq) ? globalThis.Number(object.seq) : 0,
      button1: isSet(object.button1) ? globalThis.Boolean(object.button1) : false,
      button2: isSet(object.button2) ? globalThis.Boolean(object.button2) : false,
      appliedForce: isSet(object.appliedForce) ? Vector3.fromJSON(object.appliedForce) : undefined,
      reference: isSet(object.reference) ? Pose.fromJSON(object.reference) : undefined,
      jointTorque: globalThis.Array.isArray(object?.jointTorque)
        ? object.jointTorque.map((e: any) => globalThis.Number(e))
        : [],
      errorCode: isSet(object.errorCode) ? globalThis.Number(object.errorCode) : 0,
      calibrationStatus: isSet(object.calibrationStatus) ? globalThis.Number(object.calibrationStatus) : 0,
      angularVelocity: isSet(object.angularVelocity) ? Vector3.fromJSON(object.angularVelocity) : undefined,
      updateRateHz: isSet(object.updateRateHz) ? globalThis.Number(object.updateRateHz) : 0,
      commandedPose: isSet(object.commandedPose) ? Pose.fromJSON(object.commandedPose) : undefined,
    };
  },

  toJSON(message: TouchDeviceSample): unknown {
    const obj: any = {};
    if (message.pose !== undefined) {
      obj.pose = Pose.toJSON(message.pose);
    }
    if (message.velocity !== undefined) {
      obj.velocity = Vector3.toJSON(message.velocity);
    }
    if (message.seq !== 0) {
      obj.seq = Math.round(message.seq);
    }
    if (message.button1 !== false) {
      obj.button1 = message.button1;
    }
    if (message.button2 !== false) {
      obj.button2 = message.button2;
    }
    if (message.appliedForce !== undefined) {
      obj.appliedForce = Vector3.toJSON(message.appliedForce);
    }
    if (message.reference !== undefined) {
      obj.reference = Pose.toJSON(message.reference);
    }
    if (message.jointTorque?.length) {
      obj.jointTorque = message.jointTorque;
    }
    if (message.errorCode !== 0) {
      obj.errorCode = Math.round(message.errorCode);
    }
    if (message.calibrationStatus !== 0) {
      obj.calibrationStatus = Math.round(message.calibrationStatus);
    }
    if (message.angularVelocity !== undefined) {
      obj.angularVelocity = Vector3.toJSON(message.angularVelocity);
    }
    if (message.updateRateHz !== 0) {
      obj.updateRateHz = message.updateRateHz;
    }
    if (message.commandedPose !== undefined) {
      obj.commandedPose = Pose.toJSON(message.commandedPose);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TouchDeviceSample>, I>>(base?: I): TouchDeviceSample {
    return TouchDeviceSample.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TouchDeviceSample>, I>>(object: I): TouchDeviceSample {
    const message = createBaseTouchDeviceSample();
    message.pose = (object.pose !== undefined && object.pose !== null) ? Pose.fromPartial(object.pose) : undefined;
    message.velocity = (object.velocity !== undefined && object.velocity !== null)
      ? Vector3.fromPartial(object.velocity)
      : undefined;
    message.seq = object.seq ?? 0;
    message.button1 = object.button1 ?? false;
    message.button2 = object.button2 ?? false;
    message.appliedForce = (object.appliedForce !== undefined && object.appliedForce !== null)
      ? Vector3.fromPartial(object.appliedForce)
      : undefined;
    message.reference = (object.reference !== undefined && object.reference !== null)
      ? Pose.fromPartial(object.reference)
      : undefined;
    message.jointTorque = object.jointTorque?.map((e) => e) || [];
    message.errorCode = object.errorCode ?? 0;
    message.calibrationStatus = object.calibrationStatus ?? 0;
    message.angularVelocity = (object.angularVelocity !== undefined && object.angularVelocity !== null)
      ? Vector3.fromPartial(object.angularVelocity)
      : undefined;
    message.updateRateHz = object.updateRateHz ?? 0;
    message.commandedPose = (object.commandedPose !== undefined && object.commandedPose !== null)
      ? Pose.fromPartial(object.commandedPose)
      : undefined;
    return message;
  },
};

function createBaseEmpty(): Empty {
  return {};
}

export const Empty: MessageFns<Empty> = {
  encode(_: Empty, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Empty {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEmpty();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): Empty {
    return {};
  },

  toJSON(_: Empty): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<Empty>, I>>(base?: I): Empty {
    return Empty.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Empty>, I>>(_: I): Empty {
    const message = createBaseEmpty();
    return message;
  },
};

function createBaseCartesianPose(): CartesianPose {
  return { x: 0, y: 0, z: 0, i: 0, j: 0, k: 0, w: 0 };
}

export const CartesianPose: MessageFns<CartesianPose> = {
  encode(message: CartesianPose, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.x !== 0) {
      writer.uint32(13).float(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(21).float(message.y);
    }
    if (message.z !== 0) {
      writer.uint32(29).float(message.z);
    }
    if (message.i !== 0) {
      writer.uint32(37).float(message.i);
    }
    if (message.j !== 0) {
      writer.uint32(45).float(message.j);
    }
    if (message.k !== 0) {
      writer.uint32(53).float(message.k);
    }
    if (message.w !== 0) {
      writer.uint32(61).float(message.w);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CartesianPose {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCartesianPose();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.x = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.y = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.z = reader.float();
          continue;
        }
        case 4: {
          if (tag !== 37) {
            break;
          }

          message.i = reader.float();
          continue;
        }
        case 5: {
          if (tag !== 45) {
            break;
          }

          message.j = reader.float();
          continue;
        }
        case 6: {
          if (tag !== 53) {
            break;
          }

          message.k = reader.float();
          continue;
        }
        case 7: {
          if (tag !== 61) {
            break;
          }

          message.w = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CartesianPose {
    return {
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      z: isSet(object.z) ? globalThis.Number(object.z) : 0,
      i: isSet(object.i) ? globalThis.Number(object.i) : 0,
      j: isSet(object.j) ? globalThis.Number(object.j) : 0,
      k: isSet(object.k) ? globalThis.Number(object.k) : 0,
      w: isSet(object.w) ? globalThis.Number(object.w) : 0,
    };
  },

  toJSON(message: CartesianPose): unknown {
    const obj: any = {};
    if (message.x !== 0) {
      obj.x = message.x;
    }
    if (message.y !== 0) {
      obj.y = message.y;
    }
    if (message.z !== 0) {
      obj.z = message.z;
    }
    if (message.i !== 0) {
      obj.i = message.i;
    }
    if (message.j !== 0) {
      obj.j = message.j;
    }
    if (message.k !== 0) {
      obj.k = message.k;
    }
    if (message.w !== 0) {
      obj.w = message.w;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CartesianPose>, I>>(base?: I): CartesianPose {
    return CartesianPose.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CartesianPose>, I>>(object: I): CartesianPose {
    const message = createBaseCartesianPose();
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.z = object.z ?? 0;
    message.i = object.i ?? 0;
    message.j = object.j ?? 0;
    message.k = object.k ?? 0;
    message.w = object.w ?? 0;
    return message;
  },
};

function createBaseGripperBounds(): GripperBounds {
  return { min: 0, max: 0 };
}

export const GripperBounds: MessageFns<GripperBounds> = {
  encode(message: GripperBounds, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.min !== 0) {
      writer.uint32(13).float(message.min);
    }
    if (message.max !== 0) {
      writer.uint32(21).float(message.max);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GripperBounds {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGripperBounds();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.min = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.max = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GripperBounds {
    return {
      min: isSet(object.min) ? globalThis.Number(object.min) : 0,
      max: isSet(object.max) ? globalThis.Number(object.max) : 0,
    };
  },

  toJSON(message: GripperBounds): unknown {
    const obj: any = {};
    if (message.min !== 0) {
      obj.min = message.min;
    }
    if (message.max !== 0) {
      obj.max = message.max;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GripperBounds>, I>>(base?: I): GripperBounds {
    return GripperBounds.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GripperBounds>, I>>(object: I): GripperBounds {
    const message = createBaseGripperBounds();
    message.min = object.min ?? 0;
    message.max = object.max ?? 0;
    return message;
  },
};

function createBaseStartTeleopPayload(): StartTeleopPayload {
  return { clientId: "", sessionConfig: undefined };
}

export const StartTeleopPayload: MessageFns<StartTeleopPayload> = {
  encode(message: StartTeleopPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }
    if (message.sessionConfig !== undefined) {
      TeleopSessionConfig.encode(message.sessionConfig, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StartTeleopPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStartTeleopPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clientId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.sessionConfig = TeleopSessionConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StartTeleopPayload {
    return {
      clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : "",
      sessionConfig: isSet(object.sessionConfig) ? TeleopSessionConfig.fromJSON(object.sessionConfig) : undefined,
    };
  },

  toJSON(message: StartTeleopPayload): unknown {
    const obj: any = {};
    if (message.clientId !== "") {
      obj.clientId = message.clientId;
    }
    if (message.sessionConfig !== undefined) {
      obj.sessionConfig = TeleopSessionConfig.toJSON(message.sessionConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StartTeleopPayload>, I>>(base?: I): StartTeleopPayload {
    return StartTeleopPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StartTeleopPayload>, I>>(object: I): StartTeleopPayload {
    const message = createBaseStartTeleopPayload();
    message.clientId = object.clientId ?? "";
    message.sessionConfig = (object.sessionConfig !== undefined && object.sessionConfig !== null)
      ? TeleopSessionConfig.fromPartial(object.sessionConfig)
      : undefined;
    return message;
  },
};

function createBaseStopTeleopPayload(): StopTeleopPayload {
  return { clientId: undefined, errorMessage: undefined };
}

export const StopTeleopPayload: MessageFns<StopTeleopPayload> = {
  encode(message: StopTeleopPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clientId !== undefined) {
      writer.uint32(10).string(message.clientId);
    }
    if (message.errorMessage !== undefined) {
      writer.uint32(18).string(message.errorMessage);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StopTeleopPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStopTeleopPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clientId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.errorMessage = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StopTeleopPayload {
    return {
      clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : undefined,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : undefined,
    };
  },

  toJSON(message: StopTeleopPayload): unknown {
    const obj: any = {};
    if (message.clientId !== undefined) {
      obj.clientId = message.clientId;
    }
    if (message.errorMessage !== undefined) {
      obj.errorMessage = message.errorMessage;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<StopTeleopPayload>, I>>(base?: I): StopTeleopPayload {
    return StopTeleopPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<StopTeleopPayload>, I>>(object: I): StopTeleopPayload {
    const message = createBaseStopTeleopPayload();
    message.clientId = object.clientId ?? undefined;
    message.errorMessage = object.errorMessage ?? undefined;
    return message;
  },
};

function createBaseTeleopClient(): TeleopClient {
  return { clientId: "", clientType: "", connectedAt: undefined };
}

export const TeleopClient: MessageFns<TeleopClient> = {
  encode(message: TeleopClient, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.clientId !== "") {
      writer.uint32(10).string(message.clientId);
    }
    if (message.clientType !== "") {
      writer.uint32(18).string(message.clientType);
    }
    if (message.connectedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.connectedAt), writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeleopClient {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeleopClient();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.clientId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.clientType = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.connectedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeleopClient {
    return {
      clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : "",
      clientType: isSet(object.clientType) ? globalThis.String(object.clientType) : "",
      connectedAt: isSet(object.connectedAt) ? fromJsonTimestamp(object.connectedAt) : undefined,
    };
  },

  toJSON(message: TeleopClient): unknown {
    const obj: any = {};
    if (message.clientId !== "") {
      obj.clientId = message.clientId;
    }
    if (message.clientType !== "") {
      obj.clientType = message.clientType;
    }
    if (message.connectedAt !== undefined) {
      obj.connectedAt = message.connectedAt.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeleopClient>, I>>(base?: I): TeleopClient {
    return TeleopClient.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeleopClient>, I>>(object: I): TeleopClient {
    const message = createBaseTeleopClient();
    message.clientId = object.clientId ?? "";
    message.clientType = object.clientType ?? "";
    message.connectedAt = object.connectedAt ?? undefined;
    return message;
  },
};

function createBaseTeleopState(): TeleopState {
  return {
    config: undefined,
    status: 0,
    errors: [],
    botsInSync: false,
    robotFrame: 0,
    gripperBounds: undefined,
    connectedClients: [],
    filterType: "",
    globalMode: undefined,
  };
}

export const TeleopState: MessageFns<TeleopState> = {
  encode(message: TeleopState, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      TeleopSessionConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status);
    }
    for (const v of message.errors) {
      writer.uint32(26).string(v!);
    }
    if (message.botsInSync !== false) {
      writer.uint32(32).bool(message.botsInSync);
    }
    if (message.robotFrame !== 0) {
      writer.uint32(40).int32(message.robotFrame);
    }
    if (message.gripperBounds !== undefined) {
      GripperBounds.encode(message.gripperBounds, writer.uint32(50).fork()).join();
    }
    for (const v of message.connectedClients) {
      TeleopClient.encode(v!, writer.uint32(58).fork()).join();
    }
    if (message.filterType !== "") {
      writer.uint32(66).string(message.filterType);
    }
    if (message.globalMode !== undefined) {
      writer.uint32(72).int32(message.globalMode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeleopState {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeleopState();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = TeleopSessionConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.errors.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.botsInSync = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.robotFrame = reader.int32() as any;
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.gripperBounds = GripperBounds.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.connectedClients.push(TeleopClient.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.filterType = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.globalMode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeleopState {
    return {
      config: isSet(object.config) ? TeleopSessionConfig.fromJSON(object.config) : undefined,
      status: isSet(object.status) ? teleopStatusFromJSON(object.status) : 0,
      errors: globalThis.Array.isArray(object?.errors) ? object.errors.map((e: any) => globalThis.String(e)) : [],
      botsInSync: isSet(object.botsInSync) ? globalThis.Boolean(object.botsInSync) : false,
      robotFrame: isSet(object.robotFrame) ? robotFrameFromJSON(object.robotFrame) : 0,
      gripperBounds: isSet(object.gripperBounds) ? GripperBounds.fromJSON(object.gripperBounds) : undefined,
      connectedClients: globalThis.Array.isArray(object?.connectedClients)
        ? object.connectedClients.map((e: any) => TeleopClient.fromJSON(e))
        : [],
      filterType: isSet(object.filterType) ? globalThis.String(object.filterType) : "",
      globalMode: isSet(object.globalMode) ? teleopModeFromJSON(object.globalMode) : undefined,
    };
  },

  toJSON(message: TeleopState): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = TeleopSessionConfig.toJSON(message.config);
    }
    if (message.status !== 0) {
      obj.status = teleopStatusToJSON(message.status);
    }
    if (message.errors?.length) {
      obj.errors = message.errors;
    }
    if (message.botsInSync !== false) {
      obj.botsInSync = message.botsInSync;
    }
    if (message.robotFrame !== 0) {
      obj.robotFrame = robotFrameToJSON(message.robotFrame);
    }
    if (message.gripperBounds !== undefined) {
      obj.gripperBounds = GripperBounds.toJSON(message.gripperBounds);
    }
    if (message.connectedClients?.length) {
      obj.connectedClients = message.connectedClients.map((e) => TeleopClient.toJSON(e));
    }
    if (message.filterType !== "") {
      obj.filterType = message.filterType;
    }
    if (message.globalMode !== undefined) {
      obj.globalMode = teleopModeToJSON(message.globalMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeleopState>, I>>(base?: I): TeleopState {
    return TeleopState.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeleopState>, I>>(object: I): TeleopState {
    const message = createBaseTeleopState();
    message.config = (object.config !== undefined && object.config !== null)
      ? TeleopSessionConfig.fromPartial(object.config)
      : undefined;
    message.status = object.status ?? 0;
    message.errors = object.errors?.map((e) => e) || [];
    message.botsInSync = object.botsInSync ?? false;
    message.robotFrame = object.robotFrame ?? 0;
    message.gripperBounds = (object.gripperBounds !== undefined && object.gripperBounds !== null)
      ? GripperBounds.fromPartial(object.gripperBounds)
      : undefined;
    message.connectedClients = object.connectedClients?.map((e) => TeleopClient.fromPartial(e)) || [];
    message.filterType = object.filterType ?? "";
    message.globalMode = object.globalMode ?? undefined;
    return message;
  },
};

function createBaseBoltHeadPosition(): BoltHeadPosition {
  return { pitch: 0, yaw: 0, roll: 0 };
}

export const BoltHeadPosition: MessageFns<BoltHeadPosition> = {
  encode(message: BoltHeadPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.pitch !== 0) {
      writer.uint32(13).float(message.pitch);
    }
    if (message.yaw !== 0) {
      writer.uint32(21).float(message.yaw);
    }
    if (message.roll !== 0) {
      writer.uint32(29).float(message.roll);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BoltHeadPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBoltHeadPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 13) {
            break;
          }

          message.pitch = reader.float();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.yaw = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.roll = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BoltHeadPosition {
    return {
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : 0,
      yaw: isSet(object.yaw) ? globalThis.Number(object.yaw) : 0,
      roll: isSet(object.roll) ? globalThis.Number(object.roll) : 0,
    };
  },

  toJSON(message: BoltHeadPosition): unknown {
    const obj: any = {};
    if (message.pitch !== 0) {
      obj.pitch = message.pitch;
    }
    if (message.yaw !== 0) {
      obj.yaw = message.yaw;
    }
    if (message.roll !== 0) {
      obj.roll = message.roll;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BoltHeadPosition>, I>>(base?: I): BoltHeadPosition {
    return BoltHeadPosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BoltHeadPosition>, I>>(object: I): BoltHeadPosition {
    const message = createBaseBoltHeadPosition();
    message.pitch = object.pitch ?? 0;
    message.yaw = object.yaw ?? 0;
    message.roll = object.roll ?? 0;
    return message;
  },
};

function createBaseDemonstrationSession(): DemonstrationSession {
  return {
    recordingId: "",
    frameTransform: undefined,
    replayStartTimestamp: undefined,
    replayEndTimestamp: undefined,
    playbackSpeedMultiplier: undefined,
  };
}

export const DemonstrationSession: MessageFns<DemonstrationSession> = {
  encode(message: DemonstrationSession, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.recordingId !== "") {
      writer.uint32(10).string(message.recordingId);
    }
    if (message.frameTransform !== undefined) {
      CartesianPose.encode(message.frameTransform, writer.uint32(18).fork()).join();
    }
    if (message.replayStartTimestamp !== undefined) {
      writer.uint32(25).double(message.replayStartTimestamp);
    }
    if (message.replayEndTimestamp !== undefined) {
      writer.uint32(33).double(message.replayEndTimestamp);
    }
    if (message.playbackSpeedMultiplier !== undefined) {
      writer.uint32(41).double(message.playbackSpeedMultiplier);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DemonstrationSession {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDemonstrationSession();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.recordingId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.frameTransform = CartesianPose.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.replayStartTimestamp = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 33) {
            break;
          }

          message.replayEndTimestamp = reader.double();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.playbackSpeedMultiplier = reader.double();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DemonstrationSession {
    return {
      recordingId: isSet(object.recordingId) ? globalThis.String(object.recordingId) : "",
      frameTransform: isSet(object.frameTransform) ? CartesianPose.fromJSON(object.frameTransform) : undefined,
      replayStartTimestamp: isSet(object.replayStartTimestamp)
        ? globalThis.Number(object.replayStartTimestamp)
        : undefined,
      replayEndTimestamp: isSet(object.replayEndTimestamp) ? globalThis.Number(object.replayEndTimestamp) : undefined,
      playbackSpeedMultiplier: isSet(object.playbackSpeedMultiplier)
        ? globalThis.Number(object.playbackSpeedMultiplier)
        : undefined,
    };
  },

  toJSON(message: DemonstrationSession): unknown {
    const obj: any = {};
    if (message.recordingId !== "") {
      obj.recordingId = message.recordingId;
    }
    if (message.frameTransform !== undefined) {
      obj.frameTransform = CartesianPose.toJSON(message.frameTransform);
    }
    if (message.replayStartTimestamp !== undefined) {
      obj.replayStartTimestamp = message.replayStartTimestamp;
    }
    if (message.replayEndTimestamp !== undefined) {
      obj.replayEndTimestamp = message.replayEndTimestamp;
    }
    if (message.playbackSpeedMultiplier !== undefined) {
      obj.playbackSpeedMultiplier = message.playbackSpeedMultiplier;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DemonstrationSession>, I>>(base?: I): DemonstrationSession {
    return DemonstrationSession.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DemonstrationSession>, I>>(object: I): DemonstrationSession {
    const message = createBaseDemonstrationSession();
    message.recordingId = object.recordingId ?? "";
    message.frameTransform = (object.frameTransform !== undefined && object.frameTransform !== null)
      ? CartesianPose.fromPartial(object.frameTransform)
      : undefined;
    message.replayStartTimestamp = object.replayStartTimestamp ?? undefined;
    message.replayEndTimestamp = object.replayEndTimestamp ?? undefined;
    message.playbackSpeedMultiplier = object.playbackSpeedMultiplier ?? undefined;
    return message;
  },
};

function createBaseTeleopSessionConfig(): TeleopSessionConfig {
  return {
    isSecondary: undefined,
    bots: [],
    enableBoltHeadTracking: undefined,
    modeOverride: undefined,
    gripperVelocityOverride: undefined,
    gripperMinOverride: undefined,
    gripperMaxOverride: undefined,
    demonstrationSession: undefined,
  };
}

export const TeleopSessionConfig: MessageFns<TeleopSessionConfig> = {
  encode(message: TeleopSessionConfig, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.isSecondary !== undefined) {
      writer.uint32(24).bool(message.isSecondary);
    }
    for (const v of message.bots) {
      writer.uint32(34).string(v!);
    }
    if (message.enableBoltHeadTracking !== undefined) {
      writer.uint32(40).bool(message.enableBoltHeadTracking);
    }
    if (message.modeOverride !== undefined) {
      writer.uint32(48).int32(message.modeOverride);
    }
    if (message.gripperVelocityOverride !== undefined) {
      writer.uint32(57).double(message.gripperVelocityOverride);
    }
    if (message.gripperMinOverride !== undefined) {
      writer.uint32(65).double(message.gripperMinOverride);
    }
    if (message.gripperMaxOverride !== undefined) {
      writer.uint32(73).double(message.gripperMaxOverride);
    }
    if (message.demonstrationSession !== undefined) {
      DemonstrationSession.encode(message.demonstrationSession, writer.uint32(82).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeleopSessionConfig {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeleopSessionConfig();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.isSecondary = reader.bool();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.bots.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.enableBoltHeadTracking = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.modeOverride = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.gripperVelocityOverride = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.gripperMinOverride = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.gripperMaxOverride = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.demonstrationSession = DemonstrationSession.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeleopSessionConfig {
    return {
      isSecondary: isSet(object.isSecondary) ? globalThis.Boolean(object.isSecondary) : undefined,
      bots: globalThis.Array.isArray(object?.bots) ? object.bots.map((e: any) => globalThis.String(e)) : [],
      enableBoltHeadTracking: isSet(object.enableBoltHeadTracking)
        ? globalThis.Boolean(object.enableBoltHeadTracking)
        : undefined,
      modeOverride: isSet(object.modeOverride) ? teleopModeFromJSON(object.modeOverride) : undefined,
      gripperVelocityOverride: isSet(object.gripperVelocityOverride)
        ? globalThis.Number(object.gripperVelocityOverride)
        : undefined,
      gripperMinOverride: isSet(object.gripperMinOverride) ? globalThis.Number(object.gripperMinOverride) : undefined,
      gripperMaxOverride: isSet(object.gripperMaxOverride) ? globalThis.Number(object.gripperMaxOverride) : undefined,
      demonstrationSession: isSet(object.demonstrationSession)
        ? DemonstrationSession.fromJSON(object.demonstrationSession)
        : undefined,
    };
  },

  toJSON(message: TeleopSessionConfig): unknown {
    const obj: any = {};
    if (message.isSecondary !== undefined) {
      obj.isSecondary = message.isSecondary;
    }
    if (message.bots?.length) {
      obj.bots = message.bots;
    }
    if (message.enableBoltHeadTracking !== undefined) {
      obj.enableBoltHeadTracking = message.enableBoltHeadTracking;
    }
    if (message.modeOverride !== undefined) {
      obj.modeOverride = teleopModeToJSON(message.modeOverride);
    }
    if (message.gripperVelocityOverride !== undefined) {
      obj.gripperVelocityOverride = message.gripperVelocityOverride;
    }
    if (message.gripperMinOverride !== undefined) {
      obj.gripperMinOverride = message.gripperMinOverride;
    }
    if (message.gripperMaxOverride !== undefined) {
      obj.gripperMaxOverride = message.gripperMaxOverride;
    }
    if (message.demonstrationSession !== undefined) {
      obj.demonstrationSession = DemonstrationSession.toJSON(message.demonstrationSession);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeleopSessionConfig>, I>>(base?: I): TeleopSessionConfig {
    return TeleopSessionConfig.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeleopSessionConfig>, I>>(object: I): TeleopSessionConfig {
    const message = createBaseTeleopSessionConfig();
    message.isSecondary = object.isSecondary ?? undefined;
    message.bots = object.bots?.map((e) => e) || [];
    message.enableBoltHeadTracking = object.enableBoltHeadTracking ?? undefined;
    message.modeOverride = object.modeOverride ?? undefined;
    message.gripperVelocityOverride = object.gripperVelocityOverride ?? undefined;
    message.gripperMinOverride = object.gripperMinOverride ?? undefined;
    message.gripperMaxOverride = object.gripperMaxOverride ?? undefined;
    message.demonstrationSession = (object.demonstrationSession !== undefined && object.demonstrationSession !== null)
      ? DemonstrationSession.fromPartial(object.demonstrationSession)
      : undefined;
    return message;
  },
};

function createBaseToggleBotPayload(): ToggleBotPayload {
  return { botId: "", isEnabled: false };
}

export const ToggleBotPayload: MessageFns<ToggleBotPayload> = {
  encode(message: ToggleBotPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.botId !== "") {
      writer.uint32(10).string(message.botId);
    }
    if (message.isEnabled !== false) {
      writer.uint32(16).bool(message.isEnabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ToggleBotPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseToggleBotPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.botId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.isEnabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ToggleBotPayload {
    return {
      botId: isSet(object.botId) ? globalThis.String(object.botId) : "",
      isEnabled: isSet(object.isEnabled) ? globalThis.Boolean(object.isEnabled) : false,
    };
  },

  toJSON(message: ToggleBotPayload): unknown {
    const obj: any = {};
    if (message.botId !== "") {
      obj.botId = message.botId;
    }
    if (message.isEnabled !== false) {
      obj.isEnabled = message.isEnabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ToggleBotPayload>, I>>(base?: I): ToggleBotPayload {
    return ToggleBotPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ToggleBotPayload>, I>>(object: I): ToggleBotPayload {
    const message = createBaseToggleBotPayload();
    message.botId = object.botId ?? "";
    message.isEnabled = object.isEnabled ?? false;
    return message;
  },
};

function createBaseSetRatioControlPayload(): SetRatioControlPayload {
  return { enabled: false, movementValue: 0, rotationValue: undefined };
}

export const SetRatioControlPayload: MessageFns<SetRatioControlPayload> = {
  encode(message: SetRatioControlPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.enabled !== false) {
      writer.uint32(8).bool(message.enabled);
    }
    if (message.movementValue !== 0) {
      writer.uint32(21).float(message.movementValue);
    }
    if (message.rotationValue !== undefined) {
      writer.uint32(29).float(message.rotationValue);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetRatioControlPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRatioControlPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.enabled = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.movementValue = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.rotationValue = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetRatioControlPayload {
    return {
      enabled: isSet(object.enabled) ? globalThis.Boolean(object.enabled) : false,
      movementValue: isSet(object.movementValue) ? globalThis.Number(object.movementValue) : 0,
      rotationValue: isSet(object.rotationValue) ? globalThis.Number(object.rotationValue) : undefined,
    };
  },

  toJSON(message: SetRatioControlPayload): unknown {
    const obj: any = {};
    if (message.enabled !== false) {
      obj.enabled = message.enabled;
    }
    if (message.movementValue !== 0) {
      obj.movementValue = message.movementValue;
    }
    if (message.rotationValue !== undefined) {
      obj.rotationValue = message.rotationValue;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetRatioControlPayload>, I>>(base?: I): SetRatioControlPayload {
    return SetRatioControlPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetRatioControlPayload>, I>>(object: I): SetRatioControlPayload {
    const message = createBaseSetRatioControlPayload();
    message.enabled = object.enabled ?? false;
    message.movementValue = object.movementValue ?? 0;
    message.rotationValue = object.rotationValue ?? undefined;
    return message;
  },
};

function createBaseSetGripperBoundsPayload(): SetGripperBoundsPayload {
  return { bounds: undefined };
}

export const SetGripperBoundsPayload: MessageFns<SetGripperBoundsPayload> = {
  encode(message: SetGripperBoundsPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.bounds !== undefined) {
      GripperBounds.encode(message.bounds, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetGripperBoundsPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetGripperBoundsPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.bounds = GripperBounds.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetGripperBoundsPayload {
    return { bounds: isSet(object.bounds) ? GripperBounds.fromJSON(object.bounds) : undefined };
  },

  toJSON(message: SetGripperBoundsPayload): unknown {
    const obj: any = {};
    if (message.bounds !== undefined) {
      obj.bounds = GripperBounds.toJSON(message.bounds);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetGripperBoundsPayload>, I>>(base?: I): SetGripperBoundsPayload {
    return SetGripperBoundsPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetGripperBoundsPayload>, I>>(object: I): SetGripperBoundsPayload {
    const message = createBaseSetGripperBoundsPayload();
    message.bounds = (object.bounds !== undefined && object.bounds !== null)
      ? GripperBounds.fromPartial(object.bounds)
      : undefined;
    return message;
  },
};

function createBaseSetRobotFramePayload(): SetRobotFramePayload {
  return { frame: 0 };
}

export const SetRobotFramePayload: MessageFns<SetRobotFramePayload> = {
  encode(message: SetRobotFramePayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.frame !== 0) {
      writer.uint32(8).int32(message.frame);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetRobotFramePayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetRobotFramePayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.frame = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetRobotFramePayload {
    return { frame: isSet(object.frame) ? robotFrameFromJSON(object.frame) : 0 };
  },

  toJSON(message: SetRobotFramePayload): unknown {
    const obj: any = {};
    if (message.frame !== 0) {
      obj.frame = robotFrameToJSON(message.frame);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetRobotFramePayload>, I>>(base?: I): SetRobotFramePayload {
    return SetRobotFramePayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetRobotFramePayload>, I>>(object: I): SetRobotFramePayload {
    const message = createBaseSetRobotFramePayload();
    message.frame = object.frame ?? 0;
    return message;
  },
};

function createBaseSetBoltHeadPositionPayload(): SetBoltHeadPositionPayload {
  return { position: undefined };
}

export const SetBoltHeadPositionPayload: MessageFns<SetBoltHeadPositionPayload> = {
  encode(message: SetBoltHeadPositionPayload, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.position !== undefined) {
      BoltHeadPosition.encode(message.position, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SetBoltHeadPositionPayload {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetBoltHeadPositionPayload();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.position = BoltHeadPosition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetBoltHeadPositionPayload {
    return { position: isSet(object.position) ? BoltHeadPosition.fromJSON(object.position) : undefined };
  },

  toJSON(message: SetBoltHeadPositionPayload): unknown {
    const obj: any = {};
    if (message.position !== undefined) {
      obj.position = BoltHeadPosition.toJSON(message.position);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetBoltHeadPositionPayload>, I>>(base?: I): SetBoltHeadPositionPayload {
    return SetBoltHeadPositionPayload.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetBoltHeadPositionPayload>, I>>(object: I): SetBoltHeadPositionPayload {
    const message = createBaseSetBoltHeadPositionPayload();
    message.position = (object.position !== undefined && object.position !== null)
      ? BoltHeadPosition.fromPartial(object.position)
      : undefined;
    return message;
  },
};

function createBaseTeleopSettings(): TeleopSettings {
  return {
    mode: 0,
    arDevicePort: 0,
    gripperVelocity: 0,
    flipXy: undefined,
    frequency: 0,
    filterType: undefined,
    emaSmoothingFactor: undefined,
    smoothDampSmoothTime: undefined,
    smoothDampMaxAngularSpeed: undefined,
    smoothDampMaxSpeed: undefined,
    smoothDampMaxAccel: undefined,
    headPoseUdpHost: undefined,
    headPoseUdpPort: undefined,
    hapticDevicePositionScale: undefined,
    hapticDeviceRotationScale: undefined,
    hapticDeviceRotationFrame: undefined,
    hapticDeviceForceStiffnessK: undefined,
    hapticDeviceForceDampingB: undefined,
    gripperMin: undefined,
    gripperMax: undefined,
    worldCompassHeadingDeg: undefined,
    hapticDeviceGripperButtonToggle: undefined,
  };
}

export const TeleopSettings: MessageFns<TeleopSettings> = {
  encode(message: TeleopSettings, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.mode !== 0) {
      writer.uint32(8).int32(message.mode);
    }
    if (message.arDevicePort !== 0) {
      writer.uint32(16).int32(message.arDevicePort);
    }
    if (message.gripperVelocity !== 0) {
      writer.uint32(25).double(message.gripperVelocity);
    }
    if (message.flipXy !== undefined) {
      writer.uint32(32).bool(message.flipXy);
    }
    if (message.frequency !== 0) {
      writer.uint32(41).double(message.frequency);
    }
    if (message.filterType !== undefined) {
      writer.uint32(48).int32(message.filterType);
    }
    if (message.emaSmoothingFactor !== undefined) {
      writer.uint32(57).double(message.emaSmoothingFactor);
    }
    if (message.smoothDampSmoothTime !== undefined) {
      writer.uint32(65).double(message.smoothDampSmoothTime);
    }
    if (message.smoothDampMaxAngularSpeed !== undefined) {
      writer.uint32(73).double(message.smoothDampMaxAngularSpeed);
    }
    if (message.smoothDampMaxSpeed !== undefined) {
      writer.uint32(81).double(message.smoothDampMaxSpeed);
    }
    if (message.smoothDampMaxAccel !== undefined) {
      writer.uint32(89).double(message.smoothDampMaxAccel);
    }
    if (message.headPoseUdpHost !== undefined) {
      writer.uint32(98).string(message.headPoseUdpHost);
    }
    if (message.headPoseUdpPort !== undefined) {
      writer.uint32(104).int32(message.headPoseUdpPort);
    }
    if (message.hapticDevicePositionScale !== undefined) {
      writer.uint32(113).double(message.hapticDevicePositionScale);
    }
    if (message.hapticDeviceRotationScale !== undefined) {
      writer.uint32(121).double(message.hapticDeviceRotationScale);
    }
    if (message.hapticDeviceRotationFrame !== undefined) {
      writer.uint32(130).string(message.hapticDeviceRotationFrame);
    }
    if (message.hapticDeviceForceStiffnessK !== undefined) {
      writer.uint32(137).double(message.hapticDeviceForceStiffnessK);
    }
    if (message.hapticDeviceForceDampingB !== undefined) {
      writer.uint32(145).double(message.hapticDeviceForceDampingB);
    }
    if (message.gripperMin !== undefined) {
      writer.uint32(153).double(message.gripperMin);
    }
    if (message.gripperMax !== undefined) {
      writer.uint32(161).double(message.gripperMax);
    }
    if (message.worldCompassHeadingDeg !== undefined) {
      writer.uint32(169).double(message.worldCompassHeadingDeg);
    }
    if (message.hapticDeviceGripperButtonToggle !== undefined) {
      writer.uint32(176).bool(message.hapticDeviceGripperButtonToggle);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TeleopSettings {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTeleopSettings();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.mode = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.arDevicePort = reader.int32();
          continue;
        }
        case 3: {
          if (tag !== 25) {
            break;
          }

          message.gripperVelocity = reader.double();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.flipXy = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 41) {
            break;
          }

          message.frequency = reader.double();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.filterType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 57) {
            break;
          }

          message.emaSmoothingFactor = reader.double();
          continue;
        }
        case 8: {
          if (tag !== 65) {
            break;
          }

          message.smoothDampSmoothTime = reader.double();
          continue;
        }
        case 9: {
          if (tag !== 73) {
            break;
          }

          message.smoothDampMaxAngularSpeed = reader.double();
          continue;
        }
        case 10: {
          if (tag !== 81) {
            break;
          }

          message.smoothDampMaxSpeed = reader.double();
          continue;
        }
        case 11: {
          if (tag !== 89) {
            break;
          }

          message.smoothDampMaxAccel = reader.double();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.headPoseUdpHost = reader.string();
          continue;
        }
        case 13: {
          if (tag !== 104) {
            break;
          }

          message.headPoseUdpPort = reader.int32();
          continue;
        }
        case 14: {
          if (tag !== 113) {
            break;
          }

          message.hapticDevicePositionScale = reader.double();
          continue;
        }
        case 15: {
          if (tag !== 121) {
            break;
          }

          message.hapticDeviceRotationScale = reader.double();
          continue;
        }
        case 16: {
          if (tag !== 130) {
            break;
          }

          message.hapticDeviceRotationFrame = reader.string();
          continue;
        }
        case 17: {
          if (tag !== 137) {
            break;
          }

          message.hapticDeviceForceStiffnessK = reader.double();
          continue;
        }
        case 18: {
          if (tag !== 145) {
            break;
          }

          message.hapticDeviceForceDampingB = reader.double();
          continue;
        }
        case 19: {
          if (tag !== 153) {
            break;
          }

          message.gripperMin = reader.double();
          continue;
        }
        case 20: {
          if (tag !== 161) {
            break;
          }

          message.gripperMax = reader.double();
          continue;
        }
        case 21: {
          if (tag !== 169) {
            break;
          }

          message.worldCompassHeadingDeg = reader.double();
          continue;
        }
        case 22: {
          if (tag !== 176) {
            break;
          }

          message.hapticDeviceGripperButtonToggle = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TeleopSettings {
    return {
      mode: isSet(object.mode) ? teleopModeFromJSON(object.mode) : 0,
      arDevicePort: isSet(object.arDevicePort) ? globalThis.Number(object.arDevicePort) : 0,
      gripperVelocity: isSet(object.gripperVelocity) ? globalThis.Number(object.gripperVelocity) : 0,
      flipXy: isSet(object.flipXy) ? globalThis.Boolean(object.flipXy) : undefined,
      frequency: isSet(object.frequency) ? globalThis.Number(object.frequency) : 0,
      filterType: isSet(object.filterType) ? teleopFilterTypeFromJSON(object.filterType) : undefined,
      emaSmoothingFactor: isSet(object.emaSmoothingFactor) ? globalThis.Number(object.emaSmoothingFactor) : undefined,
      smoothDampSmoothTime: isSet(object.smoothDampSmoothTime)
        ? globalThis.Number(object.smoothDampSmoothTime)
        : undefined,
      smoothDampMaxAngularSpeed: isSet(object.smoothDampMaxAngularSpeed)
        ? globalThis.Number(object.smoothDampMaxAngularSpeed)
        : undefined,
      smoothDampMaxSpeed: isSet(object.smoothDampMaxSpeed) ? globalThis.Number(object.smoothDampMaxSpeed) : undefined,
      smoothDampMaxAccel: isSet(object.smoothDampMaxAccel) ? globalThis.Number(object.smoothDampMaxAccel) : undefined,
      headPoseUdpHost: isSet(object.headPoseUdpHost) ? globalThis.String(object.headPoseUdpHost) : undefined,
      headPoseUdpPort: isSet(object.headPoseUdpPort) ? globalThis.Number(object.headPoseUdpPort) : undefined,
      hapticDevicePositionScale: isSet(object.hapticDevicePositionScale)
        ? globalThis.Number(object.hapticDevicePositionScale)
        : undefined,
      hapticDeviceRotationScale: isSet(object.hapticDeviceRotationScale)
        ? globalThis.Number(object.hapticDeviceRotationScale)
        : undefined,
      hapticDeviceRotationFrame: isSet(object.hapticDeviceRotationFrame)
        ? globalThis.String(object.hapticDeviceRotationFrame)
        : undefined,
      hapticDeviceForceStiffnessK: isSet(object.hapticDeviceForceStiffnessK)
        ? globalThis.Number(object.hapticDeviceForceStiffnessK)
        : undefined,
      hapticDeviceForceDampingB: isSet(object.hapticDeviceForceDampingB)
        ? globalThis.Number(object.hapticDeviceForceDampingB)
        : undefined,
      gripperMin: isSet(object.gripperMin) ? globalThis.Number(object.gripperMin) : undefined,
      gripperMax: isSet(object.gripperMax) ? globalThis.Number(object.gripperMax) : undefined,
      worldCompassHeadingDeg: isSet(object.worldCompassHeadingDeg)
        ? globalThis.Number(object.worldCompassHeadingDeg)
        : undefined,
      hapticDeviceGripperButtonToggle: isSet(object.hapticDeviceGripperButtonToggle)
        ? globalThis.Boolean(object.hapticDeviceGripperButtonToggle)
        : undefined,
    };
  },

  toJSON(message: TeleopSettings): unknown {
    const obj: any = {};
    if (message.mode !== 0) {
      obj.mode = teleopModeToJSON(message.mode);
    }
    if (message.arDevicePort !== 0) {
      obj.arDevicePort = Math.round(message.arDevicePort);
    }
    if (message.gripperVelocity !== 0) {
      obj.gripperVelocity = message.gripperVelocity;
    }
    if (message.flipXy !== undefined) {
      obj.flipXy = message.flipXy;
    }
    if (message.frequency !== 0) {
      obj.frequency = message.frequency;
    }
    if (message.filterType !== undefined) {
      obj.filterType = teleopFilterTypeToJSON(message.filterType);
    }
    if (message.emaSmoothingFactor !== undefined) {
      obj.emaSmoothingFactor = message.emaSmoothingFactor;
    }
    if (message.smoothDampSmoothTime !== undefined) {
      obj.smoothDampSmoothTime = message.smoothDampSmoothTime;
    }
    if (message.smoothDampMaxAngularSpeed !== undefined) {
      obj.smoothDampMaxAngularSpeed = message.smoothDampMaxAngularSpeed;
    }
    if (message.smoothDampMaxSpeed !== undefined) {
      obj.smoothDampMaxSpeed = message.smoothDampMaxSpeed;
    }
    if (message.smoothDampMaxAccel !== undefined) {
      obj.smoothDampMaxAccel = message.smoothDampMaxAccel;
    }
    if (message.headPoseUdpHost !== undefined) {
      obj.headPoseUdpHost = message.headPoseUdpHost;
    }
    if (message.headPoseUdpPort !== undefined) {
      obj.headPoseUdpPort = Math.round(message.headPoseUdpPort);
    }
    if (message.hapticDevicePositionScale !== undefined) {
      obj.hapticDevicePositionScale = message.hapticDevicePositionScale;
    }
    if (message.hapticDeviceRotationScale !== undefined) {
      obj.hapticDeviceRotationScale = message.hapticDeviceRotationScale;
    }
    if (message.hapticDeviceRotationFrame !== undefined) {
      obj.hapticDeviceRotationFrame = message.hapticDeviceRotationFrame;
    }
    if (message.hapticDeviceForceStiffnessK !== undefined) {
      obj.hapticDeviceForceStiffnessK = message.hapticDeviceForceStiffnessK;
    }
    if (message.hapticDeviceForceDampingB !== undefined) {
      obj.hapticDeviceForceDampingB = message.hapticDeviceForceDampingB;
    }
    if (message.gripperMin !== undefined) {
      obj.gripperMin = message.gripperMin;
    }
    if (message.gripperMax !== undefined) {
      obj.gripperMax = message.gripperMax;
    }
    if (message.worldCompassHeadingDeg !== undefined) {
      obj.worldCompassHeadingDeg = message.worldCompassHeadingDeg;
    }
    if (message.hapticDeviceGripperButtonToggle !== undefined) {
      obj.hapticDeviceGripperButtonToggle = message.hapticDeviceGripperButtonToggle;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TeleopSettings>, I>>(base?: I): TeleopSettings {
    return TeleopSettings.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TeleopSettings>, I>>(object: I): TeleopSettings {
    const message = createBaseTeleopSettings();
    message.mode = object.mode ?? 0;
    message.arDevicePort = object.arDevicePort ?? 0;
    message.gripperVelocity = object.gripperVelocity ?? 0;
    message.flipXy = object.flipXy ?? undefined;
    message.frequency = object.frequency ?? 0;
    message.filterType = object.filterType ?? undefined;
    message.emaSmoothingFactor = object.emaSmoothingFactor ?? undefined;
    message.smoothDampSmoothTime = object.smoothDampSmoothTime ?? undefined;
    message.smoothDampMaxAngularSpeed = object.smoothDampMaxAngularSpeed ?? undefined;
    message.smoothDampMaxSpeed = object.smoothDampMaxSpeed ?? undefined;
    message.smoothDampMaxAccel = object.smoothDampMaxAccel ?? undefined;
    message.headPoseUdpHost = object.headPoseUdpHost ?? undefined;
    message.headPoseUdpPort = object.headPoseUdpPort ?? undefined;
    message.hapticDevicePositionScale = object.hapticDevicePositionScale ?? undefined;
    message.hapticDeviceRotationScale = object.hapticDeviceRotationScale ?? undefined;
    message.hapticDeviceRotationFrame = object.hapticDeviceRotationFrame ?? undefined;
    message.hapticDeviceForceStiffnessK = object.hapticDeviceForceStiffnessK ?? undefined;
    message.hapticDeviceForceDampingB = object.hapticDeviceForceDampingB ?? undefined;
    message.gripperMin = object.gripperMin ?? undefined;
    message.gripperMax = object.gripperMax ?? undefined;
    message.worldCompassHeadingDeg = object.worldCompassHeadingDeg ?? undefined;
    message.hapticDeviceGripperButtonToggle = object.hapticDeviceGripperButtonToggle ?? undefined;
    return message;
  },
};

/** @language: python */
export interface TeleopBotService {
  GetTeleopState(request: Empty): Promise<TeleopState>;
  ToggleBot(request: ToggleBotPayload): Promise<TeleopState>;
  StartTeleop(request: StartTeleopPayload): Promise<TeleopState>;
  StopTeleop(request: StopTeleopPayload): Promise<TeleopState>;
  /**
   * ConfigureTeleop is the persistent-config push path. Feathers-bot's
   * teleopSettings service event subscriber sends the record here on
   * startup and on every UI write. Teleop-bot's TeleopManager swaps
   * the active modality accordingly.
   */
  ConfigureTeleop(request: TeleopSettings): Promise<TeleopState>;
  SetTeleopSessionConfig(request: TeleopSessionConfig): Promise<TeleopState>;
  SetRatioControl(request: SetRatioControlPayload): Promise<TeleopState>;
  SetGripperBounds(request: SetGripperBoundsPayload): Promise<TeleopState>;
  SetRobotFrame(request: SetRobotFramePayload): Promise<TeleopState>;
  SetBoltHeadPosition(request: SetBoltHeadPositionPayload): Promise<TeleopState>;
}

export const TeleopBotServiceServiceName = "teleopbot.TeleopBotService";
export class TeleopBotServiceClientImpl implements TeleopBotService {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TeleopBotServiceServiceName;
    this.rpc = rpc;
    this.GetTeleopState = this.GetTeleopState.bind(this);
    this.ToggleBot = this.ToggleBot.bind(this);
    this.StartTeleop = this.StartTeleop.bind(this);
    this.StopTeleop = this.StopTeleop.bind(this);
    this.ConfigureTeleop = this.ConfigureTeleop.bind(this);
    this.SetTeleopSessionConfig = this.SetTeleopSessionConfig.bind(this);
    this.SetRatioControl = this.SetRatioControl.bind(this);
    this.SetGripperBounds = this.SetGripperBounds.bind(this);
    this.SetRobotFrame = this.SetRobotFrame.bind(this);
    this.SetBoltHeadPosition = this.SetBoltHeadPosition.bind(this);
  }
  GetTeleopState(request: Empty): Promise<TeleopState> {
    const data = Empty.encode(request).finish();
    const promise = this.rpc.request(this.service, "GetTeleopState", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  ToggleBot(request: ToggleBotPayload): Promise<TeleopState> {
    const data = ToggleBotPayload.encode(request).finish();
    const promise = this.rpc.request(this.service, "ToggleBot", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  StartTeleop(request: StartTeleopPayload): Promise<TeleopState> {
    const data = StartTeleopPayload.encode(request).finish();
    const promise = this.rpc.request(this.service, "StartTeleop", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  StopTeleop(request: StopTeleopPayload): Promise<TeleopState> {
    const data = StopTeleopPayload.encode(request).finish();
    const promise = this.rpc.request(this.service, "StopTeleop", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  ConfigureTeleop(request: TeleopSettings): Promise<TeleopState> {
    const data = TeleopSettings.encode(request).finish();
    const promise = this.rpc.request(this.service, "ConfigureTeleop", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  SetTeleopSessionConfig(request: TeleopSessionConfig): Promise<TeleopState> {
    const data = TeleopSessionConfig.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetTeleopSessionConfig", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  SetRatioControl(request: SetRatioControlPayload): Promise<TeleopState> {
    const data = SetRatioControlPayload.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetRatioControl", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  SetGripperBounds(request: SetGripperBoundsPayload): Promise<TeleopState> {
    const data = SetGripperBoundsPayload.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetGripperBounds", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  SetRobotFrame(request: SetRobotFramePayload): Promise<TeleopState> {
    const data = SetRobotFramePayload.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetRobotFrame", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }

  SetBoltHeadPosition(request: SetBoltHeadPositionPayload): Promise<TeleopState> {
    const data = SetBoltHeadPositionPayload.encode(request).finish();
    const promise = this.rpc.request(this.service, "SetBoltHeadPosition", data);
    return promise.then((data) => TeleopState.decode(new BinaryReader(data)));
  }
}

/** @language: python */
export interface TeleopBotTopics {
  /**
   * Published on every TeleopStatus transition. Subscribers (the routine-runner
   * Teleop and RunDemonstration steps) react to teleop completion and errors
   * via this push instead of polling GetTeleopState. The payload is the full
   * TeleopState so a subscriber can act on it directly if it wants to.
   */
  StateChanged(request: TeleopState): Promise<Empty>;
}

export const TeleopBotTopicsServiceName = "teleopbot.TeleopBotTopics";
export class TeleopBotTopicsClientImpl implements TeleopBotTopics {
  private readonly rpc: Rpc;
  private readonly service: string;
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TeleopBotTopicsServiceName;
    this.rpc = rpc;
    this.StateChanged = this.StateChanged.bind(this);
  }
  StateChanged(request: TeleopState): Promise<Empty> {
    const data = TeleopState.encode(request).finish();
    const promise = this.rpc.request(this.service, "StateChanged", data);
    return promise.then((data) => Empty.decode(new BinaryReader(data)));
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>;
}

type ProtoMetaMessageOptions = {
  options?: { [key: string]: any };
  fields?: { [key: string]: { [key: string]: any } };
  oneof?: { [key: string]: { [key: string]: any } };
  nested?: { [key: string]: ProtoMetaMessageOptions };
};

export interface ProtoMetadata {
  fileDescriptor: FileDescriptorProto1;
  references: { [key: string]: any };
  dependencies?: ProtoMetadata[];
  options?: {
    options?: { [key: string]: any };
    services?: {
      [key: string]: { options?: { [key: string]: any }; methods?: { [key: string]: { [key: string]: any } } };
    };
    messages?: { [key: string]: ProtoMetaMessageOptions };
    enums?: { [key: string]: { options?: { [key: string]: any }; values?: { [key: string]: { [key: string]: any } } } };
  };
}

export const protoMetadata: ProtoMetadata = {
  fileDescriptor: {
    "name": "messenger/teleop_bot_service.proto",
    "package": "teleopbot",
    "dependency": ["google/protobuf/timestamp.proto", "messenger/geometry.proto"],
    "publicDependency": [],
    "weakDependency": [],
    "messageType": [{
      "name": "TouchDeviceSample",
      "field": [{
        "name": "pose",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "pose",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "velocity",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "velocity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "seq",
        "number": 3,
        "label": 1,
        "type": 4,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "seq",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "button_1",
        "number": 4,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "button1",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "button_2",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "button2",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "applied_force",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "appliedForce",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "reference",
        "number": 7,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "reference",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "joint_torque",
        "number": 8,
        "label": 3,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "jointTorque",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "error_code",
        "number": 9,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "errorCode",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "calibration_status",
        "number": 10,
        "label": 1,
        "type": 13,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "calibrationStatus",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "angular_velocity",
        "number": 11,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Vector3",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "angularVelocity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "update_rate_hz",
        "number": 12,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "updateRateHz",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "commanded_pose",
        "number": 13,
        "label": 1,
        "type": 11,
        "typeName": ".geometry.Pose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "commandedPose",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "Empty",
      "field": [],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "CartesianPose",
      "field": [{
        "name": "x",
        "number": 1,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "x",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "y",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "y",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "z",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "z",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "i",
        "number": 4,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "i",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "j",
        "number": 5,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "j",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "k",
        "number": 6,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "k",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "w",
        "number": 7,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "w",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "GripperBounds",
      "field": [{
        "name": "min",
        "number": 1,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "min",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "max",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "max",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StartTeleopPayload",
      "field": [{
        "name": "client_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "clientId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "session_config",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.TeleopSessionConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "sessionConfig",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_session_config", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "StopTeleopPayload",
      "field": [{
        "name": "client_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "clientId",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "error_message",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "errorMessage",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_client_id", "options": undefined }, { "name": "_error_message", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TeleopClient",
      "field": [{
        "name": "client_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "clientId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "client_type",
        "number": 2,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "clientType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "connected_at",
        "number": 3,
        "label": 1,
        "type": 11,
        "typeName": ".google.protobuf.Timestamp",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "connectedAt",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TeleopState",
      "field": [{
        "name": "config",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.TeleopSessionConfig",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "config",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "status",
        "number": 2,
        "label": 1,
        "type": 14,
        "typeName": ".teleopbot.TeleopStatus",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "status",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "errors",
        "number": 3,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "errors",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "bots_in_sync",
        "number": 4,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "botsInSync",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "robot_frame",
        "number": 5,
        "label": 1,
        "type": 14,
        "typeName": ".teleopbot.RobotFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "robotFrame",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "gripper_bounds",
        "number": 6,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.GripperBounds",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gripperBounds",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "connected_clients",
        "number": 7,
        "label": 3,
        "type": 11,
        "typeName": ".teleopbot.TeleopClient",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "connectedClients",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "filter_type",
        "number": 8,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "filterType",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "global_mode",
        "number": 9,
        "label": 1,
        "type": 14,
        "typeName": ".teleopbot.TeleopMode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "globalMode",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_gripper_bounds", "options": undefined }, {
        "name": "_global_mode",
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "BoltHeadPosition",
      "field": [{
        "name": "pitch",
        "number": 1,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "pitch",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "yaw",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "yaw",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "roll",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "roll",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "DemonstrationSession",
      "field": [{
        "name": "recording_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "recordingId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "frame_transform",
        "number": 2,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.CartesianPose",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "frameTransform",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "replay_start_timestamp",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "replayStartTimestamp",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "replay_end_timestamp",
        "number": 4,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "replayEndTimestamp",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "playback_speed_multiplier",
        "number": 5,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "playbackSpeedMultiplier",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_frame_transform", "options": undefined },
        { "name": "_replay_start_timestamp", "options": undefined },
        { "name": "_replay_end_timestamp", "options": undefined },
        { "name": "_playback_speed_multiplier", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TeleopSessionConfig",
      "field": [{
        "name": "is_secondary",
        "number": 3,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "isSecondary",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "bots",
        "number": 4,
        "label": 3,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "bots",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "enable_bolt_head_tracking",
        "number": 5,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "enableBoltHeadTracking",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "mode_override",
        "number": 6,
        "label": 1,
        "type": 14,
        "typeName": ".teleopbot.TeleopMode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "modeOverride",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "gripper_velocity_override",
        "number": 7,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "gripperVelocityOverride",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "gripper_min_override",
        "number": 8,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 4,
        "jsonName": "gripperMinOverride",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "gripper_max_override",
        "number": 9,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 5,
        "jsonName": "gripperMaxOverride",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "demonstration_session",
        "number": 10,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.DemonstrationSession",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 6,
        "jsonName": "demonstrationSession",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_is_secondary", "options": undefined },
        { "name": "_enable_bolt_head_tracking", "options": undefined },
        { "name": "_mode_override", "options": undefined },
        { "name": "_gripper_velocity_override", "options": undefined },
        { "name": "_gripper_min_override", "options": undefined },
        { "name": "_gripper_max_override", "options": undefined },
        { "name": "_demonstration_session", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "ToggleBotPayload",
      "field": [{
        "name": "bot_id",
        "number": 1,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "botId",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "is_enabled",
        "number": 2,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "isEnabled",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetRatioControlPayload",
      "field": [{
        "name": "enabled",
        "number": 1,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "enabled",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "movement_value",
        "number": 2,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "movementValue",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "rotation_value",
        "number": 3,
        "label": 1,
        "type": 2,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "rotationValue",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [{ "name": "_rotation_value", "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetGripperBoundsPayload",
      "field": [{
        "name": "bounds",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.GripperBounds",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "bounds",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetRobotFramePayload",
      "field": [{
        "name": "frame",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".teleopbot.RobotFrame",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "frame",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "SetBoltHeadPositionPayload",
      "field": [{
        "name": "position",
        "number": 1,
        "label": 1,
        "type": 11,
        "typeName": ".teleopbot.BoltHeadPosition",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "position",
        "options": undefined,
        "proto3Optional": false,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TeleopSettings",
      "field": [{
        "name": "mode",
        "number": 1,
        "label": 1,
        "type": 14,
        "typeName": ".teleopbot.TeleopMode",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "mode",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "ar_device_port",
        "number": 2,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "arDevicePort",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "gripper_velocity",
        "number": 3,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "gripperVelocity",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "flip_xy",
        "number": 4,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "flipXy",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "frequency",
        "number": 5,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 0,
        "jsonName": "frequency",
        "options": undefined,
        "proto3Optional": false,
      }, {
        "name": "filter_type",
        "number": 6,
        "label": 1,
        "type": 14,
        "typeName": ".teleopbot.TeleopFilterType",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 1,
        "jsonName": "filterType",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "ema_smoothing_factor",
        "number": 7,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 2,
        "jsonName": "emaSmoothingFactor",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "smooth_damp_smooth_time",
        "number": 8,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 3,
        "jsonName": "smoothDampSmoothTime",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "smooth_damp_max_angular_speed",
        "number": 9,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 4,
        "jsonName": "smoothDampMaxAngularSpeed",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "smooth_damp_max_speed",
        "number": 10,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 5,
        "jsonName": "smoothDampMaxSpeed",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "smooth_damp_max_accel",
        "number": 11,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 6,
        "jsonName": "smoothDampMaxAccel",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "head_pose_udp_host",
        "number": 12,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 7,
        "jsonName": "headPoseUdpHost",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "head_pose_udp_port",
        "number": 13,
        "label": 1,
        "type": 5,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 8,
        "jsonName": "headPoseUdpPort",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "haptic_device_position_scale",
        "number": 14,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 9,
        "jsonName": "hapticDevicePositionScale",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "haptic_device_rotation_scale",
        "number": 15,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 10,
        "jsonName": "hapticDeviceRotationScale",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "haptic_device_rotation_frame",
        "number": 16,
        "label": 1,
        "type": 9,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 11,
        "jsonName": "hapticDeviceRotationFrame",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "haptic_device_force_stiffness_k",
        "number": 17,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 12,
        "jsonName": "hapticDeviceForceStiffnessK",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "haptic_device_force_damping_b",
        "number": 18,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 13,
        "jsonName": "hapticDeviceForceDampingB",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "gripper_min",
        "number": 19,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 14,
        "jsonName": "gripperMin",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "gripper_max",
        "number": 20,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 15,
        "jsonName": "gripperMax",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "world_compass_heading_deg",
        "number": 21,
        "label": 1,
        "type": 1,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 16,
        "jsonName": "worldCompassHeadingDeg",
        "options": undefined,
        "proto3Optional": true,
      }, {
        "name": "haptic_device_gripper_button_toggle",
        "number": 22,
        "label": 1,
        "type": 8,
        "typeName": "",
        "extendee": "",
        "defaultValue": "",
        "oneofIndex": 17,
        "jsonName": "hapticDeviceGripperButtonToggle",
        "options": undefined,
        "proto3Optional": true,
      }],
      "extension": [],
      "nestedType": [],
      "enumType": [],
      "extensionRange": [],
      "oneofDecl": [
        { "name": "_flip_xy", "options": undefined },
        { "name": "_filter_type", "options": undefined },
        { "name": "_ema_smoothing_factor", "options": undefined },
        { "name": "_smooth_damp_smooth_time", "options": undefined },
        { "name": "_smooth_damp_max_angular_speed", "options": undefined },
        { "name": "_smooth_damp_max_speed", "options": undefined },
        { "name": "_smooth_damp_max_accel", "options": undefined },
        { "name": "_head_pose_udp_host", "options": undefined },
        { "name": "_head_pose_udp_port", "options": undefined },
        { "name": "_haptic_device_position_scale", "options": undefined },
        { "name": "_haptic_device_rotation_scale", "options": undefined },
        { "name": "_haptic_device_rotation_frame", "options": undefined },
        { "name": "_haptic_device_force_stiffness_k", "options": undefined },
        { "name": "_haptic_device_force_damping_b", "options": undefined },
        { "name": "_gripper_min", "options": undefined },
        { "name": "_gripper_max", "options": undefined },
        { "name": "_world_compass_heading_deg", "options": undefined },
        { "name": "_haptic_device_gripper_button_toggle", "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "enumType": [{
      "name": "TeleopStatus",
      "value": [
        { "name": "WAIT_FOR_TELEOP", "number": 0, "options": undefined },
        { "name": "TELEOP", "number": 1, "options": undefined },
        { "name": "STOPPING", "number": 2, "options": undefined },
        { "name": "STOPPED", "number": 3, "options": undefined },
        { "name": "ERROR", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "RobotFrame",
      "value": [{ "name": "WORLD", "number": 0, "options": undefined }, {
        "name": "TOOLTIP",
        "number": 1,
        "options": undefined,
      }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TeleopMode",
      "value": [
        { "name": "TELEOP_MODE_DISABLED", "number": 0, "options": undefined },
        { "name": "TELEOP_MODE_IOS", "number": 1, "options": undefined },
        { "name": "TELEOP_MODE_HEADSET", "number": 2, "options": undefined },
        { "name": "TELEOP_MODE_HAPTIC", "number": 3, "options": undefined },
        { "name": "TELEOP_MODE_DEMONSTRATION_REPLAY", "number": 4, "options": undefined },
      ],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }, {
      "name": "TeleopFilterType",
      "value": [{ "name": "TELEOP_FILTER_NONE", "number": 0, "options": undefined }, {
        "name": "TELEOP_FILTER_EMA",
        "number": 1,
        "options": undefined,
      }, { "name": "TELEOP_FILTER_SMOOTH_DAMP", "number": 2, "options": undefined }],
      "options": undefined,
      "reservedRange": [],
      "reservedName": [],
    }],
    "service": [{
      "name": "TeleopBotService",
      "method": [{
        "name": "GetTeleopState",
        "inputType": ".teleopbot.Empty",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ToggleBot",
        "inputType": ".teleopbot.ToggleBotPayload",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "StartTeleop",
        "inputType": ".teleopbot.StartTeleopPayload",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "StopTeleop",
        "inputType": ".teleopbot.StopTeleopPayload",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "ConfigureTeleop",
        "inputType": ".teleopbot.TeleopSettings",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetTeleopSessionConfig",
        "inputType": ".teleopbot.TeleopSessionConfig",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetRatioControl",
        "inputType": ".teleopbot.SetRatioControlPayload",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetGripperBounds",
        "inputType": ".teleopbot.SetGripperBoundsPayload",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetRobotFrame",
        "inputType": ".teleopbot.SetRobotFramePayload",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }, {
        "name": "SetBoltHeadPosition",
        "inputType": ".teleopbot.SetBoltHeadPositionPayload",
        "outputType": ".teleopbot.TeleopState",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }, {
      "name": "TeleopBotTopics",
      "method": [{
        "name": "StateChanged",
        "inputType": ".teleopbot.TeleopState",
        "outputType": ".teleopbot.Empty",
        "options": undefined,
        "clientStreaming": false,
        "serverStreaming": false,
      }],
      "options": undefined,
    }],
    "extension": [],
    "options": {
      "javaPackage": "",
      "javaOuterClassname": "",
      "javaMultipleFiles": false,
      "javaGenerateEqualsAndHash": false,
      "javaStringCheckUtf8": false,
      "optimizeFor": 1,
      "goPackage": "sb.app/messenger/proto/teleopbot",
      "ccGenericServices": false,
      "javaGenericServices": false,
      "pyGenericServices": false,
      "phpGenericServices": false,
      "deprecated": false,
      "ccEnableArenas": true,
      "objcClassPrefix": "",
      "csharpNamespace": "",
      "swiftPrefix": "",
      "phpClassPrefix": "",
      "phpNamespace": "",
      "phpMetadataNamespace": "",
      "rubyPackage": "",
      "uninterpretedOption": [],
    },
    "sourceCodeInfo": {
      "location": [{
        "path": [3, 1],
        "span": [3, 0, 34],
        "leadingComments": "",
        "trailingComments": ' import "google/protobuf/empty.proto";\n',
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0],
        "span": [18, 0, 57, 1],
        "leadingComments":
          " Per-tick teleop blackbox sample, published for start-jolt diagnostics. Most\n fields are the raw leader device readout — `pose`, `velocity`,\n `angular_velocity`, `joint_torque` come straight from the servo shared-memory\n block (device frame/units) before origin subtraction or scaling, and `seq` is\n the SHM frame counter so consumers can detect stale reads and ordering.\n Velocity near zero while pose moves ⇒ a reported-value artifact rather than\n physical stylus motion. A few fields are teleop-side derived, NOT raw:\n `commanded_pose` and `reference` are robot-world-frame poses (see their\n comments) — carried on the same record as the raw pose so the mapping and\n force loop can be read per-tick without joining async topics.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 1],
        "span": [20, 2, 32],
        "leadingComments": "",
        "trailingComments": " linear velocity, device units/s\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 3],
        "span": [23, 2, 20],
        "leadingComments": " Stylus button press state (Touch X has two buttons).\n",
        "trailingComments": " front / gray\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 4],
        "span": [24, 2, 20],
        "leadingComments": "",
        "trailingComments": " back / dark\n",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 5],
        "span": [31, 2, 37],
        "leadingComments":
          " --- Diagnostic fields for teleop start-jolt investigation ---\n The haptic force teleop commanded to the device this tick (device frame,\n N), and the reference pose the force loop used (compliance target, or the\n robot's actual pose when the compliance target is stale). Together with\n pose/velocity these let force = -K*(commanded - reference) and the energy\n balance (force*velocity) be computed exactly from the recording.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 7],
        "span": [39, 2, 35],
        "leadingComments":
          " Raw device actuation/health straight from libHD, to distinguish a device\n servo fault from hand motion. joint_torque is HD_CURRENT_JOINT_TORQUE (the\n motors' actual torque — nonzero here while applied_force is ~0 means the\n device drove the stylus itself). error_code is the raw hdGetError code\n (0 = HD_SUCCESS). calibration_status is hdCheckCalibration\n (0x5000 OK / 0x5001 needs-update / 0x5002 needs-manual).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 10],
        "span": [44, 2, 41],
        "leadingComments":
          " Angular velocity of the stylus (device frame, rad/s) — shows whether a\n spike is translation-only or the whole pose.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 11],
        "span": [49, 2, 29],
        "leadingComments":
          " libHD's instantaneous servo loop rate (Hz), HD_INSTANTANEOUS_UPDATE_RATE.\n libHD derives velocity as Δpose/Δt, so a dip here at the same tick as a\n velocity spike means the spike is a servo-timing artifact (a long Δt),\n not real motion or a device fault. Nominal is ~1000 Hz.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 0, 2, 12],
        "span": [56, 2, 36],
        "leadingComments":
          " The follower target pose teleop derived from `pose` this tick (robot world\n frame) — i.e. the WritePoseCompliance command — recorded on the same\n sample as the raw device `pose` (device frame). Having both in one record\n makes the mapping (origin subtraction, axis flip, ~4x position scaling)\n and any engage glitch visible per-tick without joining async topics.\n Unset until the first control tick sends a command.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 0],
        "span": [60, 0, 77, 1],
        "leadingComments": " @language: python\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 0, 2, 4],
        "span": [70, 2, 60],
        "leadingComments":
          " ConfigureTeleop is the persistent-config push path. Feathers-bot's\n teleopSettings service event subscriber sends the record here on\n startup and on every UI write. Teleop-bot's TeleopManager swaps\n the active modality accordingly.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1],
        "span": [80, 0, 86, 1],
        "leadingComments": " @language: python\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [6, 1, 2, 0],
        "span": [85, 2, 48],
        "leadingComments":
          " Published on every TeleopStatus transition. Subscribers (the routine-runner\n Teleop and RunDemonstration steps) react to teleop completion and errors\n via this push instead of polling GetTeleopState. The payload is the full\n TeleopState so a subscriber can act on it directly if it wants to.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 2],
        "span": [103, 0, 109, 1],
        "leadingComments":
          " Which teleop modality the bot is configured to run.\n DISABLED means no modality is active (teleop is effectively off).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [5, 3],
        "span": [112, 0, 116, 1],
        "leadingComments": " Pose-smoothing filter applied between leader input and follower commands.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 4, 2, 1],
        "span": [141, 2, 50],
        "leadingComments":
          " Optional per-session overrides applied atomically on start. Used\n when the caller owns the start (WebXR, Touch X) and wants to\n bundle topology + overrides into one RPC. Cleared on stop along\n with any pre-staged overrides from `SetTeleopSessionConfig`.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 7, 2, 8],
        "span": [168, 2, 38],
        "leadingComments":
          " Persisted (robot-global) teleop mode from TeleopSettings, independent of any\n session `config.mode_override`. Lets a consumer evaluate the effective mode\n (override if set, else global) from this state alone, without a separate\n settings lookup. Unset before persisted settings first arrive.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 9, 2, 2],
        "span": [185, 2, 45],
        "leadingComments":
          " Optional sphere-trim window: teleop-bot streams only frames whose\n timestamp falls in [start, end] (inclusive), anchoring the window's first\n frame to the live tooltip. Timestamps are recorder seconds. Both unset ⇒\n full recording; end alone unset ⇒ to recording end.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 9, 2, 4],
        "span": [191, 2, 48],
        "leadingComments":
          " Playback speed multiplier vs recorded cadence (1.0 ⇒ recorded). Range\n 0.1–2.0 enforced by the runner; unset ⇒ 1.0. Speed-ups are realized by\n downsampling frames teleop-bot side, not by sending faster.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 10, 2, 3],
        "span": [203, 2, 40],
        "leadingComments":
          " Session-scoped overrides. Each unset field falls back to the\n corresponding TeleopSettings (persisted) value. Cleared by\n teleop-bot on session stop, so the next session reverts to\n persisted defaults — the persisted Feathers row is never touched.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 16],
        "span": [238, 0, 286, 1],
        "leadingComments":
          " Persistent user preference, persisted in feathers-bot's teleopSettings\n Feathers service and pushed to teleop-bot via ConfigureTeleop. All tuning\n knobs a user expects the robot to remember across reboots live here.\n Per-session state (e.g. is_secondary, bots) is separate and lives in\n TeleopSessionConfig.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 16, 2, 3],
        "span": [246, 2, 28],
        "leadingComments":
          ' Marked optional so proto3 presence tracking lets SetTeleopConfig\n distinguish "client wants flipXy=false" from "client did not send flipXy"\n (a default-value bool can\'t otherwise be told apart from absence).\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 16, 2, 5],
        "span": [252, 2, 44],
        "leadingComments":
          ' Marked optional for the same SetTeleopConfig presence reason as flip_xy:\n TELEOP_FILTER_NONE (=0, "identity") is a valid user choice, so the proto3\n default must be distinguishable from "client did not send filter_type".\n',
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 16, 2, 18],
        "span": [270, 2, 35],
        "leadingComments": " Normalized 0..1; mapped onto the active leader gripper.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 16, 2, 20],
        "span": [277, 2, 49],
        "leadingComments":
          " Per-robot calibration: compass heading (degrees clockwise from true\n north) of the robot's gravity-aligned world +X axis. Required for\n iOS teleop. Absent ⇒ uncalibrated; teleop-bot refuses to start the\n iOS modality.\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }, {
        "path": [4, 16, 2, 21],
        "span": [285, 2, 57],
        "leadingComments":
          " Haptic-device gripper button (button 2) behavior. When false (default)\n the button is momentary: hold = close, release = open. When true it\n latches: each press alternates the follower gripper between its\n configured min (closed) and max (open) bounds. Marked optional so\n proto3 presence tracking lets SetTeleopConfig distinguish an explicit\n `false` from an unset field (same rationale as flip_xy).\n",
        "trailingComments": "",
        "leadingDetachedComments": [],
      }],
    },
    "syntax": "proto3",
  },
  references: {
    ".teleopbot.TeleopStatus": TeleopStatus,
    ".teleopbot.RobotFrame": RobotFrame,
    ".teleopbot.TeleopMode": TeleopMode,
    ".teleopbot.TeleopFilterType": TeleopFilterType,
    ".teleopbot.TouchDeviceSample": TouchDeviceSample,
    ".teleopbot.Empty": Empty,
    ".teleopbot.CartesianPose": CartesianPose,
    ".teleopbot.GripperBounds": GripperBounds,
    ".teleopbot.StartTeleopPayload": StartTeleopPayload,
    ".teleopbot.StopTeleopPayload": StopTeleopPayload,
    ".teleopbot.TeleopClient": TeleopClient,
    ".teleopbot.TeleopState": TeleopState,
    ".teleopbot.BoltHeadPosition": BoltHeadPosition,
    ".teleopbot.DemonstrationSession": DemonstrationSession,
    ".teleopbot.TeleopSessionConfig": TeleopSessionConfig,
    ".teleopbot.ToggleBotPayload": ToggleBotPayload,
    ".teleopbot.SetRatioControlPayload": SetRatioControlPayload,
    ".teleopbot.SetGripperBoundsPayload": SetGripperBoundsPayload,
    ".teleopbot.SetRobotFramePayload": SetRobotFramePayload,
    ".teleopbot.SetBoltHeadPositionPayload": SetBoltHeadPositionPayload,
    ".teleopbot.TeleopSettings": TeleopSettings,
    ".teleopbot.TeleopBotService": TeleopBotServiceClientImpl,
    ".teleopbot.TeleopBotTopics": TeleopBotTopicsClientImpl,
  },
  dependencies: [protoMetadata1, protoMetadata2],
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
